export default {
  dbList: state => {
    let list = []
    state.dbList.map(item => {
      list.push({
        id: item.id,
        name: item.name,
        access: ''
      })
    })
    return list
  },
  fieldsList: state => {
    const schemaObj = state.dbSchema
    const array = []
    if (Object.keys(schemaObj).length) {
      if (schemaObj.schema === null) {
        return []
      } else {
        schemaObj.schema.schema.fields.map(item => {
          array.push({
            label: item.label,
            checked: false
          })
        })
      }
      return array
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dbConstructor/getters.js